window.addEventListener('load', () => {
    let availableCarousels = document.querySelectorAll('.splide');
    let endorsementsPanel = document.querySelectorAll('.endorsements-panel')

    if (availableCarousels.length) {

        // START PRODUCT PANEL SLIDER
        for ( let panel of endorsementsPanel ) {
            let parentPanel = panel.closest('.endorsements-panel');
            let navArrows = parentPanel.querySelectorAll('.splide-nav-arrow');
            let slideCount = parentPanel.querySelector('.endorsement-splide').dataset.totalSlides;
            let progressBar = parentPanel.querySelector('.progress-bar');

            let endorsementSplide = new Splide(panel.querySelector('.endorsement-splide'), {
                type: 'loop',
                speed: 750,
                direction: 'ltr',
                pauseOnHover: true,
                arrows: false,
                gap: '4rem',
                perPage: 3,
                pagination: false,
                autoplay: false,
                padding: '2rem',
                interval: 10000,
                classes: {
                    pagination: 'splide__pagination w-full flex justify-center items-center gap-2 mt-12',
                    page      : 'splide__pagination__page rounded-full overflow-hidden w-3 h-3 bg-blue hover:brightness-110 [&.is-active]:!bg-orange transition-all duration-150 ease-in-out'
                },
                breakpoints: {
                    1024: {
                        perPage: 2,
                        padding: '1.5rem',
                    },
                    768: {
                        perPage: 1,
                        padding: '1.5rem',
                    },
                },
            });

            endorsementSplide.on('mounted move', function () {

                let slideModifier = 3;

                const smToLgMediaQuery = window.matchMedia('(max-width: 1023px)');
                const smMediaQuery = window.matchMedia('(max-width: 767px)');

                if (smToLgMediaQuery.matches) {
                    slideModifier = 2;
                }

                if (smMediaQuery.matches) {
                    slideModifier = 1;
                }

                let end = endorsementSplide.Components.Controller.getEnd() + slideModifier;


                progressBar.style.width = String(100 * (endorsementSplide.index + 1) / end) + '%';
            });

            for ( let arrow of navArrows ) {
                arrow.addEventListener('click', () => {
                    if (arrow.dataset.navigate == '+') {
                        endorsementSplide.go('+1');
                        arrow.dataset.transition = 'true';
                        setTimeout(function () {
                            arrow.dataset.transition = 'false';
                        }, 150);
                    }
                    else {
                        endorsementSplide.go('-1');
                        arrow.dataset.transition = 'true';
                        setTimeout(function () {
                            arrow.dataset.transition = 'false';
                        }, 150);
                    }
                });
            }

            endorsementSplide.mount();
        }
        // END PRODUCT PANEL SLIDER
    }
});
